<template>
  <div>
    <el-form ref="form" size="mini" :model="formData" :rules="rules">
      <div>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_quotedMethod') || '报价方式'"
              prop="quotedMethod"
            >
              <dict-select
                url="/sys/common/dict/system"
                v-model="formData.quotedMethod"
                :body="quotedMethodParams"
                :placeholder="
                  $l('INDEX.sample_tips_select_quotation_method') ||
                    '请选择报价方式'
                "
                size="mini"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_shipmentType') || '发运方式'"
              prop="shipmentType"
            >
              <dict-select
                url="/master/common/dict/biz"
                v-model="formData.shipmentType"
                :body="shipmentTypeParams"
                :placeholder="
                  $l('INDEX.form_placeholder_shipmentTypes') || '请选择发运方式'
                "
                size="mini"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    shipmentCode: { type: String, default: '' },
    shipmentBookingCodeList: { type: Array, default: () => [] },
    shipmentStatus: { type: String, default: '' },
    custCode: { type: String, default: '' },
  },
  data() {
    return {
      shipmentTypeParams: { dictType: 'shipmentType' },
      quotedMethodParams: { dictType: 'quotedMethod' },
      shipperParams: { shipmentType: 'S' },
      formData: {},
      backDialogVisible: false,
      rules: {
        deliveryDate: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_deliveryDate') ||
              '请输入产装日期',
            trigger: 'change',
          },
        ],
        bookingScmCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_bookingScm') || '请选择订舱货代',
            trigger: 'change',
          },
        ],
        customsBrokerScmCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_customsBrokerScm') ||
              '请选择报关货代',
            trigger: 'change',
          },
        ],
        transitScmCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_transitScm') || '请选择运输公司',
            trigger: 'change',
          },
        ],
        domesticShipperCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_domesticShipperCode') ||
              '请选择境内发货人',
            trigger: 'change',
          },
        ],
        overseasConsigneeCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_overseasConsigneeCode') ||
              '请选择境外收货人',
            trigger: 'change',
          },
        ],
        quotedMethod: [
          {
            required: true,
            message:
              this.$l('INDEX.sample_tips_select_quotation_method') ||
              '请选择报价方式',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    consigneeParams() {
      return { shipmentType: 'C', custCode: this.custCode }
    },
  },
  methods: {
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      const params = {
        ...this.formData,
        shipmentCode: this.shipmentCode,
        shipmentBookingCodeList: this.shipmentBookingCodeList,
      }
      this.loadingOpen()
      this.$api
        .shipmentBookingBatchEditApi(params)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.close()
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
